import React from 'react';

const Footer = () => {
    return (
        <div>
            <p><small>Copyright coming soon</small></p>
        </div>
    );
};

export default Footer;